import React, { Component } from 'react';
import { Header, Table, Button, Modal } from 'semantic-ui-react'
import axios from 'axios'
import { base, serverIp, PAYMENT_TYPE_NO_NEED_TO_PAY,PAYMENT_TYPE_STOCK } from '../../../../config/constants';


class StockPaidCell extends Component {
    constructor(props) {
        super(props);
        this.state = {
            modalOpen: false
        }
    }



    openModal = () => {
        this.setState({ modalOpen: true });
    }

    closeModal = () => {
        this.setState({ modalOpen: false });

    }

    reloadOrders = () => {
        this.props.reloadOrders;
    }

    sendPayment = () => {
        //this.makePayment("markIndyOrderStockPayment");
        this.makePayment(PAYMENT_TYPE_STOCK);

        
    }


    sendNoNeedToPay = () => {
        this.makePayment(PAYMENT_TYPE_NO_NEED_TO_PAY);
    }

    makePayment = (action) => {
        console.log("cpx1 ====== makePayment");
        console.log("cpx1: action:" + action)

        this.setState({ loading: true })

        axios.post(serverIp + 'stockPayment/markStockPayment', {
            "apiKey": "PrintB@da7",
            "fbOrderKey": this.props.order.mainOrder.fbOrderKey,
            "singleOrderKey":this.props.order.singOrderFbKey,
            "amountDep": this.props.order.shirtType.shirtTypeBuyCost,
            "adminEmail": this.props.user.email,
            "message": action
        })
            .then((response) => {

                console.log(JSON.stringify(response.data, null, 3));

                this.setState({ loading: false, modalOpen: false });

                if (response.data.result) {
                    this.props.reloadOrders();
                    alert('payment recorded');

                }else if(!response.data.result){
                    alert('Payment Failed:'+response.data.message);
                }

              
            })
            .catch((error) => {
                console.log(error);
                alert('Payment Failed');
                this.setState({
                    loading: false,
                    modalOpen: false
                })
            });
    }

    render() {
        const stockPiadUI = this.props.order.mainOrder.stockPaid === 'yes'
            ? <Header as='h2' color='green' textAlign='center'>
                {this.props.order.mainOrder.stockPaid} - {this.props.order.mainOrder.stockPaidDate}
            </Header>
            : <Button color='red'onClick={this.sendPayment} > Make Payment </Button>
            
            // <div>
            //     <Modal size={'mini'} open={this.state.modalOpen} onClose={this.close}>
            //         <Modal.Header>
            //             Make Payment
            //         </Modal.Header>
            //         <Modal.Content>
            //             <h3>Make Payment:{this.props.order.mainOrder.orderNum} {this.props.order.mainOrder.userz.name}?</h3>
            //         </Modal.Content>
            //         <Modal.Actions>
            //             <Button negative onClick={this.closeModal}>No</Button>
            //             <Button positive icon='checkmark' labelPosition='right' content='Yes' onClick={this.sendPayment} />
            //         </Modal.Actions>
            //     </Modal>
            //     <Button onClick={this.openModal} color='red'>MAKE PAYMENT </Button>
            // </div>

        const noNeedToPayUI = this.props.order.stockPaid === 'yes'
            ? ''
            : <div>
                <Modal size={'mini'} open={this.state.modalOpen} onClose={this.close}>
                    <Modal.Header>
                        No Need To Pay
                </Modal.Header>
                    <Modal.Content>
                        <h3>No Payment Needed:{this.props.order.mainOrder.orderNum} {this.props.order.mainOrder.userz.name}?</h3>
                    </Modal.Content>
                    <Modal.Actions>
                        <Button negative onClick={this.closeModal}>No</Button>
                        <Button positive icon='checkmark' labelPosition='right' content='Yes' onClick={this.sendNoNeedToPay} />
                    </Modal.Actions>
                </Modal>
                <Button onClick={this.openModal} color='teal'>NO PAY NEEDED </Button>
            </div>

        return (
            <div>
                {stockPiadUI}
                {noNeedToPayUI}
            </div>
        )
    }
}

export default StockPaidCell;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/StockPayment/StockPaidCell.js